import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
// import { trigger, state, style , animate, transition, query, stagger  } from '@angular/animations';
import { UserManager } from "../../Services/UserManager/user-manager";
import { VgApiService } from "@videogular/ngx-videogular/core";
import {
  transition,
  state,
  style,
  animate,
  trigger,
} from "@angular/animations";
import { Subject } from "rxjs";
import { LanguageSwitchService } from "../../Services/LanguageSwitch/language-switch.service";

@Component({
  selector: "app-bradshaw",
  templateUrl: "./bradshaw.component.html",
  styleUrls: ["./bradshaw.component.css", "../../app.component.css"],
  animations: [
    trigger("item", [
      state("void", style({ opacity: 0, transform: "translateY(100px)" })),
      state("show", style({ opacity: 1, transform: "translateY(0px)" })),
      transition("void => *", [animate("600ms ease-in-out")]),
      // transition('* => void',[ animate('300ms ease-in-out')]),
    ]),
  ],
})
export class BradshawComponent implements OnInit, OnDestroy {
  config;
  video;
  api: VgApiService;
  videoReady = "show";
  profile;
  leaving = new Subject();
  constructor(
    private router: Router,
    private um: UserManager,
    private ls: LanguageSwitchService
  ) {
    this.ls.config.subscribe({
      next: (config) => {
        this.config = config;
      },
    });
  }

  ngOnInit() {
    this.um
      .getProfileSubject()
      .takeUntil(this.leaving)
      .subscribe((profile) => (this.profile = profile));
  }

  ngOnDestroy() {
    this.leaving.next();
  }

  register() {
    this.um.openSignUpAndThenGoToLesson();
  }

  gotoLessons() {
    this.router.navigate(["lessons-information"]);
  }
  start(e) {
    // console.log(e)
  }

  end(e) {
    // console.log(e)
  }

  // async gotoCurrentLesson() {
  //   let loggedIn = await this.um.isLoggedIn()
  //   if (loggedIn) {
  //     this.um.gotoLessonHeader();
  //   } else {
  //     this.um.gotoLessonHeader(1);
  //   }
  // }
}
